export function formatDate(value: string, language: string): string {
  return new Intl.DateTimeFormat(language.startsWith('vi') ? 'vi-VN' : 'en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  }).format(new Date(value));
}
